<p-toast position="top-right"></p-toast>
<app-loading-spinner></app-loading-spinner>
<p-confirmDialog [style]="{ width: '450px', 'background-color': '#fae7cc' }"></p-confirmDialog>
<router-outlet></router-outlet>
